export const NAV_LEAVE_ACTION = {
  CANCEL: "cancel",
  DISCARD: "discard",
  SAVE: "save",
};

let confirmNavigationHandler = null;

export function setNavigationConfirm(handler) {
  confirmNavigationHandler = handler;
}

export function confirmNavigationLeave(message) {
  const defaultMessage = "You have unsaved changes. What would you like to do?";
  const prompt = message || defaultMessage;

  if (confirmNavigationHandler) {
    return confirmNavigationHandler(prompt);
  }

  const shouldLeave = window.confirm(`${prompt}\n\nPress OK to leave without saving, or Cancel to stay.`);
  return Promise.resolve(shouldLeave ? NAV_LEAVE_ACTION.DISCARD : NAV_LEAVE_ACTION.CANCEL);
}
